import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import { useSelector } from "react-redux";
import apiInstance from "../../../../utility/apiInstance";

interface SettingsLinksProps {
  refreshKey?: number;
}

const SettingsLinks = ({ refreshKey }: SettingsLinksProps) => {
  const route = all_routes;
  const location = useLocation();
  const user = useSelector((state: any) => state.auth.user);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user?.id) return;
    const fetchUnread = async () => {
      try {
        const res = await apiInstance.get("/api/notifications", {
          params: {
            "where[recipient][equals]": user.id,
            "where[read][not_equals]": true,
            limit: 0,
          },
        });
        setUnreadCount(res.data.totalDocs ?? 0);
      } catch {
        // silently ignore
      }
    };
    fetchUnread();
  }, [user?.id, location.pathname, refreshKey]);

  const isAccountManager = user?.role === "account_manager";

  return (
      <>
          <ul className="settings-nav d-flex align-items-center flex-wrap border bg-light-900 rounded">
              <li>
                  <Link
                      to={route.recruiterSettings}
                      className={`${location.pathname === "/recruiter/recruiter-settings" ? "active" : ""}`}
                  >
                      Profile
                  </Link>
              </li>
              {!isAccountManager && (
                  <li>
                      <Link
                          to={route.recruiterBusinessProfile}
                          className={`${location.pathname === "/recruiter/recruiter-business-profile" ? "active" : ""}`}
                      >
                          Business Profile
                      </Link>
                  </li>
              )}
              {!isAccountManager && (
                  <li>
                      <Link
                          to={route.recruiterCommissions}
                          className={`${location.pathname === "/recruiter/recruiter-commissions" ? "active" : ""}`}
                      >
                          Commissions
                      </Link>
                  </li>
              )}
              {!isAccountManager && (
                  <li>
                      <Link
                          to={route.recruiterDocuments}
                          className={`${location.pathname === "/recruiter/recruiter-documents" ? "active" : ""}`}
                      >
                          Documents
                      </Link>
                  </li>
              )}
              <li>
                  <Link
                      to={route.recruiterNotifications}
                      className={`d-inline-flex align-items-center gap-2 ${location.pathname === "/recruiter/recruiter-notifications" ? "active" : ""}`}
                  >
                      Notifications
                      {unreadCount > 0 && (
                          <span className="badge bg-primary rounded-pill" style={{ fontSize: "0.7rem" }}>
                              {unreadCount}
                          </span>
                      )}
                  </Link>
              </li>
              <li>
                  <Link
                      to={route.recruiterChangePassword}
                      className={`${location.pathname === "/recruiter/recruiter-change-password" ? "active" : ""}`}
                  >
                      Change Password
                  </Link>
              </li>
          </ul>
      </>
  );
};

export default SettingsLinks;
